import dateFormat from './date-format';
import { round } from './number';

export default {
  install (Vue) {
    Vue.filter('date-format', dateFormat);
    Vue.filter('round', round);
  },
};
